
export const TYPE_INITIALIZE_COURSE = "initializeCourse"
export const TYPE_GOTO_NEXT = "gotoNext";
export const TYPE_GOTO_PREVIOUS = "gotoPrevious";
export const TYPE_GOTO_MENU = "gotoMenu";
export const TYPE_GOTO_LOCATION = "gotoLocation";
export const TYPE_TOGGLE_RESOURCES = "toggleResources";
export const TYPE_STATUS_COMPLETE = "statusComplete";
export const TYPE_UPDATE_PAGE_STATUS = "updatePageStatus";
export const TYPE_SET_AUDIO = "setAudio";
export const TYPE_SET_AUDIO_STATUS = "setAudioStatus";
export const TYPE_SET_AUDIO_EVENT = "setAudioEvent";
export const TYPE_SET_ALERT = "setAlert";

export const gotoNextPage = () => ({
    type: TYPE_GOTO_NEXT
})

export const gotoPreviousPage = () => ({
    type: TYPE_GOTO_PREVIOUS
})

export const gotoMenu = () => ({
    type: TYPE_GOTO_MENU
})

export const gotoLocation = (locationArray) => ({
    type: TYPE_GOTO_LOCATION,
    payload: locationArray
})

export const completePage = () => ({
    type: TYPE_STATUS_COMPLETE
})

export const toggleResources = (resourcesVisible, resourcesSelection) => ({
    type: TYPE_TOGGLE_RESOURCES,
    payload: {resourcesVisible, resourcesSelection},
});

export const setAudio = (audioData) => ({
    type: TYPE_SET_AUDIO,
    payload: audioData
})

export const setAudioStatus = (audioStatus) => ({
    type: TYPE_SET_AUDIO_STATUS,
    payload: audioStatus
})

export const setAudioEvent = (audioEvent) => ({
    type: TYPE_SET_AUDIO_EVENT,
    payload: audioEvent
})

export const setAlert = (alertData) => ({
    type: TYPE_SET_ALERT,
    payload: alertData
})

export const updatePageStatus = (statusArray) =>({
    type: TYPE_UPDATE_PAGE_STATUS,
    payload: statusArray
})

export const initializeCourse = (data) =>({
    type:TYPE_INITIALIZE_COURSE,
    payload: data
})




